import React from 'react';
import { getMetaDescription } from '@/utils/getMetaDescription';
import Layout from '@/components/Layout';
import Shop from '../../containers/Shop';
import { useSetSSRStore, useSSRSelector } from '../../redux';
import getServerSideProps from 'src/pageUtils/getServerSideProps/shop/categoryName';

export { getServerSideProps };

const ShopPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  return (
    <Layout
      store={storeInfo}
      title={`${storeInfo?.store_info?.name}${
        storeInfo?.address?.city
          ? Boolean(storeInfo?.address?.visibility === 1)
            ? `, ${storeInfo?.address?.city}`
            : ''
          : ''
      } - Order Online`}
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={storeInfo && getMetaDescription(storeInfo)}
      OGImage={storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <section>
        <Shop {...props} />
      </section>
    </Layout>
  );
};

export default ShopPage;
